
async function renderWishlistPage() {
  document.querySelectorAll('[class*="wishlist-page-"]').forEach(async (section) => {
    const grid = section.querySelector('[data-wishlist-grid]');
    const emptyEl = section.querySelector('[data-wishlist-empty]');
    const subheading = section.querySelector('[data-wishlist-subheading]');

    if (!grid || !window.UnistarWishlist) return;

    const items = window.UnistarWishlist.getAll();

    if (subheading) {
      subheading.textContent =
        items.length === 0
          ? 'Nothing saved yet.'
          : items.length +
            ' book' +
            (items.length !== 1 ? 's' : '') +
            ' saved for later.';
    }

    if (items.length === 0) {
      grid.style.display = 'none';

      if (emptyEl) {
        emptyEl.style.display = 'block';
      }

      return;
    }

    grid.style.display = '';
    
    if (emptyEl) {
      emptyEl.style.display = 'none';
    }

    /*
     * Fetch Shopify product JSON for every wishlist item.
     * This gives us:
     * - product type
     * - compare-at price
     * - availability
     * - variant ID
     * - actual product handle
     */
    const products = await Promise.all(
      items.map(async (item) => {
        try {
          let handle = item.handle;

          /*
           * If handle is not stored in wishlist,
           * try to get it from the product URL.
           */
          if (!handle && item.url) {
            const match = item.url.match(/\/products\/([^/?#]+)/);

            if (match) {
              handle = match[1];
            }
          }

          if (!handle) {
            return {
              ...item,
              _product: null
            };
          }

          const response = await fetch(
            `/products/${handle}.js`,
            {
              credentials: 'same-origin'
            }
          );

          if (!response.ok) {
            throw new Error('Product could not be loaded');
          }

          const product = await response.json();

          return {
            ...item,
            handle: handle,
            _product: product
          };

        } catch (error) {
          console.warn(
            'Wishlist product could not be loaded:',
            item.title,
            error
          );

          return {
            ...item,
            _product: null
          };
        }
      })
    );

    /*
     * Use the SAME product-grid class as Shop page.
     */
    grid.className = 'shop-products-grid';

    grid.innerHTML = products
      .map((item) => {

        const product = item._product;

        /*
         * Product information
         */
        const title = product?.title || item.title || '';

        const url =
          item.url ||
          (item.handle
            ? `/products/${item.handle}`
            : '#');

        const image =
          product?.featured_image ||
          item.image ||
          '';

        const productType =
          product?.type ||
          '';

        /*
         * Shopify product JSON prices are in cents.
         */
   const price = Number(product.price || 0);

const compareAtPrice = Number(
  product.compare_at_price || 0
);;

     const isBundleProduct =
  product?.tags?.includes('unistar-bundle') ||
  item?.tags?.includes('unistar-bundle') ||
  false;

const available =
  product?.available !== false || isBundleProduct;
        /*
         * First available variant.
         */
        const variant =
          product?.variants?.find(
            (variant) => variant.available
          ) ||
          product?.variants?.[0];

        const variantId =
          variant?.id ||
          item.variant_id ||
          '';

        /*
         * Sale condition
         */
        const isSale =
          compareAtPrice > price;

        /*
         * Wishlist ID
         */
        const wishlistId =
          item.id ||
          item.product_id ||
          '';

        return `
          <div
            class="shop-product-card wishlist-product-card"
            data-wishlist-item="${wishlistId}"
          >

            <!-- PRODUCT IMAGE -->
            <div class="shop-product-image">

              <a href="${url}">

                ${
                  image
                    ? `
                      <img
                        src="${image}"
                        alt="${escapeWishlistHtml(title)}"
                        loading="lazy"
                      >
                    `
                    : `
                      <div
                        style="
                          width:100%;
                          height:100%;
                          display:flex;
                          align-items:center;
                          justify-content:center;
                        "
                      >
                        No Image
                      </div>
                    `
                }

              </a>

              ${
                isSale
                  ? `
                    <span class="shop-sale-badge">
                      Sale
                    </span>
                  `
                  : ''
              }

              ${
                !available
                  ? `
                    <span class="shop-sold-badge">
                      Sold Out
                    </span>
                  `
                  : ''
              }


              <!-- SAME SHOP ACTIONS -->
              <div class="shop-product-actions">

                <!-- ADD TO CART -->
                ${
                  available && variantId
                    ? `
                      <button
                        type="button"
                        class="shop-action-btn shop-add-cart pc-add-to-cart"
                        data-product-id="${wishlistId}"
                        data-variant-id="${variantId}"
                        data-product-title="${escapeWishlistHtml(title)}"
                        aria-label="Add ${escapeWishlistHtml(title)} to cart"
                      >
                        <svg viewBox="0 0 24 24" width="26" height="26" fill="none"><path d="M6 6h15l-1.5 9h-12L6 6zm0 0L5 3H2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="20" r="1.2" fill="currentColor"/><circle cx="17" cy="20" r="1.2" fill="currentColor"/></svg>
         
                      </button>
                    `
                    : ''
                }


                <!-- REMOVE FROM WISHLIST -->
                <button
                  type="button"
                  class="shop-action-btn wishlist-remove-btn"
                  data-remove-id="${wishlistId}"
                  aria-label="Remove ${escapeWishlistHtml(title)} from wishlist"
                  title="Remove from wishlist"
                >
                  <i class="fa-solid fa-heart"></i>
                </button>

              </div>

            </div>


            <!-- PRODUCT CONTENT -->
            <div class="shop-product-content">

              ${
                productType
                  ? `
                    <div class="shop-product-category">
                      ${escapeWishlistHtml(productType)}
                    </div>
                  `
                  : ''
              }


              <h3 class="shop-product-title">
                <a href="${url}">
                  ${escapeWishlistHtml(title)}
                </a>
              </h3>


              <div class="shop-product-bottom">

                <div class="shop-product-price">
  ${
    compareAtPrice > price
      ? `<span class="shop-old-price">
          Rs. ${(compareAtPrice / 100).toFixed(2)}
         </span>`
      : ''
  }

  <span class="shop-current-price">
    Rs. ${(price / 100).toFixed(2)}
  </span>
</div>

              </div>

            </div>

          </div>
        `;
      })
      .join('');


    /*
     * REMOVE FROM WISHLIST
     */
    grid.querySelectorAll('.wishlist-remove-btn').forEach((button) => {

      button.addEventListener('click', function () {

        const id = this.dataset.removeId;

        if (!id) return;

        window.UnistarWishlist.remove(id);

        /*
         * Re-render immediately.
         */
        renderWishlistPage();
      });

    });

  });
}


/*
 * Escape HTML so product titles/images cannot
 * break the generated card markup.
 */
function escapeWishlistHtml(value) {

  if (value == null) return '';

  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}


/*
 * Wishlist updated event
 */
document.addEventListener(
  'wishlist:updated',
  renderWishlistPage
);


/*
 * Initial render
 */
if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    renderWishlistPage
  );

} else {

  renderWishlistPage();

}


/*
 * Shopify theme editor
 */
document.addEventListener(
  'shopify:section:load',
  renderWishlistPage
);
